<section class="overview__header">
	<ng-content select="app-overview-header"/>
	<ng-content select="[appOverviewHeader]"/>
</section>
<section class="overview__table">
	<ng-content select="app-table"/>
	<ng-content select="app-table-skeleton"/>
</section>
